import React from "react";
import { useTranslation } from "react-i18next";

const SocketBroken = () => {
  const { t } = useTranslation("common");
  console.log("test");
  return (
    <div className="flex-full-height flex-direction">
      <i className="icon-warning-icon img-bad" style={{ color: "#F8CC97" }} />
      <div className="explanation-bad no-select-text">
        <h5 style={{ marginBottom: "0px" }}>{t("state.badHeader")}</h5>
        <span className="text-size-14">{t("state.badExpl")}</span>
      </div>
    </div>
  );
};

export default React.memo(SocketBroken);
